export default {
  SET_SCROLL_TARGET_PATH: '@WS_EDITOR/SCROLLER/SET_SCROLL_TARGET_PATH',
  CLEAR_SCROLL_TARGET_PATH: '@WS_EDITOR/SCROLLER/CLEAR_SCROLL_TARGET_PATH',
};
